import styled from 'styled-components';

import { Spacer } from '@ontruck/orc';

const StyledLoadsBox = styled(Spacer)`
  border: 1px solid var(--greyWolf);
  border-radius: 4px;
`;

export default StyledLoadsBox;
